'use client';

import React, { Suspense, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ActiveThemeProvider } from '../active-theme';
import RouteLogger from './route-logger';

export default function Providers({
  activeThemeValue,
  children
}: {
  activeThemeValue: string;
  children: React.ReactNode;
}) {
  // QueryClient se crea una sola vez por mount del provider para evitar
  // recrear el cache entre renders. Usado por @tanstack/react-query
  // (introducido para metadata cacheable de Lead Discovery).
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ActiveThemeProvider initialTheme={activeThemeValue}>
        {/* RouteLogger usa useSearchParams() que en Next 15+ requiere Suspense */}
        <Suspense fallback={null}>
          <RouteLogger />
        </Suspense>
        {children}
      </ActiveThemeProvider>
    </QueryClientProvider>
  );
}
